import React from "react";
import "./Logo.css";

interface Props {
  size?: number;
  withWordmark?: boolean;
  className?: string;
}

// Brand mark — a rounded blue tile with an "S" in the top-left and an "H"
// in the bottom-right, arranged in a diagonal stagger. Both letterforms are
// stroked white paths with rounded caps, sharing a consistent line weight so
// the two glyphs read as a single visual family. Crisp at any size including
// 16×16 favicons.
//
// `size` controls the mark's pixel height (defaults to 28px). When
// `withWordmark` is true the component also renders the "SessionHoster"
// text alongside the mark, sized in proportion to the mark.
export default function Logo({ size = 28, withWordmark = false, className = "" }: Props) {
  const mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={withWordmark ? "SessionHoster logo" : "SessionHoster"}
      className="brand-mark"
    >
      <rect width="64" height="64" rx="14" fill="var(--primary-color, #2563eb)" />
      {/* S — top-left, stroked curves so it reads as an "S" rather than a "2" */}
      <path
        d="M 28 16 C 12 16, 12 22, 22 22 C 32 22, 32 32, 16 32"
        fill="none"
        stroke="#ffffff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* H — bottom-right, stroked to match the S */}
      <path
        d="M 36 34 L 36 50 M 50 34 L 50 50 M 36 42 L 50 42"
        fill="none"
        stroke="#ffffff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (!withWordmark) {
    return <span className={`brand-logo brand-logo-mark ${className}`}>{mark}</span>;
  }
  return (
    <span className={`brand-logo brand-logo-row ${className}`}>
      {mark}
      <span className="brand-wordmark" style={{ fontSize: `${Math.round(size * 0.65)}px` }}>
        SessionHoster
      </span>
    </span>
  );
}
